import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vehicles: [],
  loading: false,
  error: null
};

const vehicleSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    setVehicles: (state, action) => {
      state.vehicles = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { setVehicles, setLoading, setError, clearError } = vehicleSlice.actions;
export default vehicleSlice.reducer; 